import { generateDates } from 'core/common/utils/generateDates';

export const shortMonthsListEn = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const monthsListEn = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const greatestBirthYear = new Date().getFullYear() - 18;

export const yearsList = generateDates(1940, greatestBirthYear, 'increment');
